import React, { useState, useEffect } from 'react';
import { Helmet } from 'react-helmet';
import Header from '../../components/ui/Header';
import CountryFilter from '../../components/ui/CountryFilter';
import TrailsHeader from './components/TrailsHeader';
import TrailsGrid from './components/TrailsGrid';
import QuickActions from './components/QuickActions';

const ThematicTrailsOverview = () => {
  const [activeFilter, setActiveFilter] = useState('all');
  const [filteredTrails, setFilteredTrails] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  // Mock trails data
  const trailsData = [
  {
    id: 'od-glecera-do-grebaje',
    name: 'Od glečera do Grebaje',
    country: 'Montenegro',
    countryFlag: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763502563/crnogorska_zastava_z81wq6.jpg",
    countryFlagAlt: 'Montenegrin flag with red field and golden border with coat of arms',
    theme: 'Natural Heritage',
    difficulty: 'Easy',
    length: '2 km',
    duration: '1 dan',
    description: `Za dolinu Grebaje kažu da je dolina kontrasta ‒ pitoma, puna ljekovitog bilja, osunčana i u proljeće bogata vodom, ali okružena ljutim kršom, opasnim vrhovima i vertikalnim liticama koje izazivaju strahopoštovanje. Upravo vas ovdje vodi prva tematska staza, u skrivene ljepote masiva Prokletija.`,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_17b15e350-1763410161435.png",
    imageAlt: 'Magična lednička dolina Ropojana sa periodičnim Ropojanskim jezerom okružena planinama',
    highlights: ['Dolina Grebaje', 'Ali-pašini izvori', 'Oko Skakavice', 'Plavsko jezero', 'Botanička bašta Velemun']
  },
  {
    id: 'legende-brskova',
    name: 'Legende i priče iz srednjovjekovnog Brskova',
    country: 'Montenegro',
    countryFlag: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763502563/crnogorska_zastava_z81wq6.jpg",
    countryFlagAlt: 'Montenegrin flag with red field and golden border with coat of arms',
    theme: 'Cultural Heritage',
    difficulty: 'Moderate',
    length: '5.4 km',
    duration: '2 dana',
    description: `Drugu tematsku stazu možemo nazvati i stazom legendi, jer vas, poput vremeplova, vraća u srednji vijek ‒ u doba Brskova, važnog srednjovjekovnog rudarskog i trgovačkog centra. Za Brskovo, na 6 kilometara od Mojkovca, na padini planine Bjelasice, vezuje se rudnik srebra, prvi iskovan novac, priče o karavanima, trgovini i životu tog doba.`,
    image: "https://images.unsplash.com/photo-1587187557124-92267d7c54b8",
    imageAlt: 'Planina Bjelasica sa pitomim travnatim vrhovima i gustim šumama na padinama',
    highlights: ['Planina Bjelasica', 'Spomenik Mojkovačke bitke', 'Manastir Majstorovina', 'Stari most na Tari', 'Zavičajni muzej Bijelo Polje']
  },
  {
    id: 'kanjon-tare',
    name: 'Kanjon Tare - priče o ljudima i rijeci',
    country: 'Montenegro',
    countryFlag: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763502563/crnogorska_zastava_z81wq6.jpg",
    countryFlagAlt: 'Montenegrin flag with red field and golden border with coat of arms',
    theme: 'River Valleys',
    difficulty: 'Easy',
    length: '45.8 km',
    duration: '1-3 dana',
    description: `Treći tematski put vas vodi duž najdubljeg kanjona u Evropi, koji je svoje mjesto pronašao i na listi najvećih kanjona u svijetu. Tokom 50 kilometara, koliko ima od Mojkovca do Đurđevića Tare, a koje možete proći kolima, motorom ili biciklom, čekaju vas fantastični vidikovci, mistične šume, jezera, rijeka sa pritokama, a tu su i manastiri koji pričaju istoriju Potarja.`,
    image: "https://images.unsplash.com/photo-1594586039874-7b112c785a4e",
    imageAlt: 'Duboki kanjon rijeke Tare sa kristalno čistom vodom okružen visokim šumovitim liticama',
    highlights: ['Kanjon Tare', 'Manastir Dobrilovina', 'Zabojsko jezero', 'Crna poda prašuma', 'Most na Đurđevića Tari']
  },
  {
    id: 'tri-jezera',
    name: 'U zagrljaju šume i tri jezera',
    country: 'Montenegro',
    countryFlag: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763502563/crnogorska_zastava_z81wq6.jpg",
    countryFlagAlt: 'Montenegrin flag with red field and golden border with coat of arms',
    theme: 'Forest Heritage',
    difficulty: 'Easy',
    length: '6 km',
    duration: '1 dan',
    description: `Magične guste šume Durmitora, karakterističan miris četinara, tragovi stanovnika ove šumske zajednice i tišina koju tek ponekad prekine neka sova ili vrijedni djetlić, čekaju vas na četvrtoj tematskoj stazi. Prateći smjerokaze, ovdje se susrećete sa tri jezera. Ipak, to nije sve. Prateći potok, nailazite na ostatke brojnih mlinova, a o njima ćete pročitati više na informativnim tablama koje se nalaze duž staze.`,
    image: "https://images.unsplash.com/photo-1655666582814-4ca8447f7f20",
    imageAlt: 'Crno jezero okruženo gustom četinarskom šumom sa maglovitim planinama u pozadini',
    highlights: ['Barno jezero', 'Zminje jezero', 'Crno jezero', 'Selo Bosača', 'Tradicionalno graditeljstvo']
  },
  {
    id: 'zivot-kroz-vekove-golija',
    name: 'Život kroz vekove – Stanovništvo Golije',
    country: 'Serbia',
    countryFlag: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763502563/srpska_zastava_slljwl.jpg",
    countryFlagAlt: 'Serbian flag with horizontal red, blue and white stripes',
    theme: 'Cultural Heritage',
    difficulty: 'Easy',
    length: '9 km',
    duration: '1 dan',
    description: `Na obroncima Golije, planine koja diše u ritmu tišine, vreme teče sporije i mirnije nego igde drugde. U selima Rudno i Biniće, između mirisa dima i hleba pečenog pod sačem, i danas se živi gotovo isto kao pre stotinu godina. Staza „Život kroz vekove – Stanovništvo Golije" vodi kroz svakodnevicu ovih planinskih sela – kroz njihove šume, livade, izvore i priče.`, image: "https://img.rocket.new/generatedImages/rocket_gen_img_168e61a2f-1763457480106.png",
    imageAlt: 'Mapa staze Život kroz vekove na planini Goliji sa označenim rutama i atrakcijama',
    highlights: ['Brevina reka', 'Košaninova jezera', 'Manastir Studenica', 'Manastir Gradac', 'Tradicionalne kuće']
  },
  {
    id: 'listening-to-medieval-serbia',
    name: 'Osluškujući damare srednjovekovne Srbije – Nemanjićevim nasleđem',
    country: 'Serbia',
    countryFlag: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763502563/srpska_zastava_slljwl.jpg",
    countryFlagAlt: 'Serbian flag with horizontal red, blue and white stripes',
    theme: 'Medieval Heritage',
    difficulty: 'Moderate',
    length: '7 km',
    duration: '1 dan',
    description: `Na obalama reke Studenice, između stena Radočela i šuma koje se spuštaju do vode, stoji tišina koja traje vekovima. Ova staza povezuje vreme i prostor, prirodu i duhovnost. Hodajući njome, čuje se kako planina diše i kako se u tišini čuju damari srednjovekovne Srbije — molitve, koraci monaha, šum reke koji nosi priču o Stefanu Nemanji i njegovim naslednicima.`,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1c8c40a5f-1763457479858.png",
    imageAlt: 'Manastir Studenica sa belim mermernim zidovima u dolini reke Studenice okružen planinama',
    highlights: ['Manastir Studenica (UNESCO)', 'Nemanjin vodovod', 'Isposnice Svetog Save', 'Košaninova jezera', 'Vodopadi Izubre']
  },
  {
    id: 'trail-details-and-there-was-water-life-of-people-in-mountains-and-water',
    name: 'I BI VODA – Život ljudi u planini i vodi',
    country: 'Serbia',
    countryFlag: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763502563/srpska_zastava_slljwl.jpg",
    countryFlagAlt: 'Serbian flag with horizontal red, blue and white stripes',
    theme: 'Water Heritage',
    difficulty: 'Easy',
    length: '8 km',
    duration: '1 dan',
    description: `Na Goliji, voda je oduvek imala dušu. U njenim potocima, izvorima i vodenicama krije se priča o životu, o ljudima koji su naučili da slušaju planinu i da poštuju svaku kap. Staza „I bi voda – Život ljudi u planini i vodi" povezuje izvore, reke i bačije, pokazujući kako je voda oblikovala svakodnevicu stanovnika Golije.`,
    image: "https://img.rocket.new/generatedImages/rocket_gen_img_1820f1499-1763458399647.png",
    imageAlt: 'Mapa staze I bi voda sa označenim vodenim objektima, vodenicama i prirodnim atrakcijama na planini Goliji',
    highlights: ['Vodenice', 'Brevina reka', 'Crkva Svete Trojice', 'Planinski potoci', 'Seoski običaji']
  },
  {
    id: 'trail-details-once-upon-a-time-myths-and-legends-of-mountain-people',
    name: 'BIO JEDNOM JEDAN – Mitovi i legende ljudi sa planine',
    country: 'Serbia',
    countryFlag: "https://res.cloudinary.com/dzt5ejpvb/image/upload/v1763502563/srpska_zastava_slljwl.jpg",
    countryFlagAlt: 'Serbian flag with horizontal red, blue and white stripes',
    theme: 'Mythology Heritage',
    difficulty: 'Moderate',
    length: '11 km',
    duration: '1 dan',
    description: `Na Goliji, svaka stena ima ime, a svaki potok – priču. Ovde vreme ne briše legende, već ih čuva u šumama, izvorima i kamenju. Staza „Bio jednom jedan – Mitovi i legende ljudi sa planine" vodi kroz područje Bojovog brda, gde su se vekovima preplitale stvarnost i predanja. Na ovom putu srećemo duhove prošlosti, hrabre junake, bogove i vile, ali i jednostavne ljude čija su srca bila veća od planine.`, image: "https://img.rocket.new/generatedImages/rocket_gen_img_1c6d1ac6b-1763458756120.png",
    imageAlt: 'Pogled sa Bojovog brda preko doline reke Moravice do Kozjih stena i vrha Jankov kamen',
    highlights: ['Bojovo brdo', 'Jankov kamen (1.833 m)', 'Reka Moravica', 'Dajićko jezero', 'Rimski most u Kumanici']
  }];

  // Filter trails based on selected country
  useEffect(() => {
    setIsLoading(true);

    // Simulate loading delay for better UX
    const timer = setTimeout(() => {
      let filtered = trailsData;

      if (activeFilter !== 'all') {
        filtered = trailsData?.filter((trail) =>
        trail?.country?.toLowerCase() === activeFilter?.toLowerCase()
        );
      }

      setFilteredTrails(filtered);
      setIsLoading(false);
    }, 300);

    return () => clearTimeout(timer);
  }, [activeFilter]);

  const handleFilterChange = (filter) => {
    setActiveFilter(filter);
  };

  return (
    <>
      <Helmet>
        <title>Thematic Trails Overview - Creative Twinning</title>
        <meta
          name="description"
          content="Discover four unique heritage and nature trails across Montenegro. Explore cultural sites, natural wonders, and authentic local experiences through carefully curated thematic routes." />

        <meta name="keywords" content="heritage trails, Serbia, Montenegro, cultural tourism, nature trails, thematic routes" />
      </Helmet>
      <div className="min-h-screen bg-background">
        <Header />
        
        <main className="pt-16">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
            {/* Page Header */}
            <TrailsHeader
              totalTrails={trailsData?.length}
              filteredCount={filteredTrails?.length}
              activeFilter={activeFilter} />


            {/* Country Filter */}
            <CountryFilter
              onFilterChange={handleFilterChange}
              activeFilter={activeFilter} />


            {/* Trails Grid */}
            <TrailsGrid
              trails={filteredTrails}
              isLoading={isLoading} />


            {/* Quick Actions */}
            <QuickActions />
          </div>
        </main>
      </div>
    </>);

};

export default ThematicTrailsOverview;